import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const researchAndStudentSlice = createSlice({
  name: "research",
  initialState: {
    research: {
      data: [],
      loading: false,
      error: null,
    },
    publication: {
      data: [],
      loading: false,
      error: null,
    },
    download: {
      loading: false,
      error: null,
    },
    societies: {
      data: [],
      loading: false,
      error: null,
    },
    events:
    {
      data:[],
      loading : false,
      error: null,
    },
    sports:
    {
      data:[],
      loading:false,
      error :null
    },

    internship:
    {
      data:[],
      loading:false,
      error :null
    },
    trainings:
    {
      data:[],
      loading:false,
      error :null
    },
    docs:
    {
      data:[],
      loading:false,
      error :null
    }
  },
  reducers: {
    fetchResearchStart(state) {
      state.research.loading = true;
      state.research.error = null;
    },
    fetchResearchSuccess(state, action) {
      state.research.loading = false;
      state.research.data = action.payload;
    },
    fetchResearchFailure(state, action) {
      state.research.loading = false;
      state.research.error = action.payload;
    },
    fetchPublicationStart(state) {
      state.publication.loading = true;
      state.publication.error = null;
    },
    fetchPublicationSucces(state, action) {
      state.publication.loading = false;
      state.publication.data = action.payload;
    },
    fetchPublicationFailure(state, action) {
      state.publication.loading = false;
      state.publication.error = action.payload;
    },
    downloadFileStart(state) {
      state.download.loading = true;
      state.download.error = null;
    },
    downloadFileSuccess(state) {
      state.download.loading = false;
    },
    downloadFileFailure(state, action) {
      state.download.loading = false;
      state.download.error = action.payload;
    },
    fetchSocitiesStart(state) {
      state.societies.loading = true;
      state.societies.error = false;
    },
    fetchSoctiesSuccess(state, action) {
      state.societies.loading = false;
      state.societies.data = action.payload;
    },
    fetchSocietiesFailure(state, action) {
      state.societies.loading = false;
      state.societies.error = action.payload;
    },
    fetchEventsStart(state)
    {
      state.events.loading = true;
      state.events.error = false;
    },
    fetchEventsSuccess(state, action) {
      state.events.loading = false;
      state.events.data = action.payload;
    },
    fetchEvetnsFailure(state, action) {
      state.events.loading = false;
      state.events.error = action.payload;
    },
    fetchSportsStart(state)
    {
      state.sports.loading = true;
      state.sports.error = false;
    },
    fetchSportsSuccess(state, action) {
      state.sports.loading = false;
      state.sports.data = action.payload;
    },
    fetchSportsFailure(state, action) {
      state.sports.loading = false;
      state.sports.error = action.payload;
    },


    fetchInternshipStart(state)
    {
      state.internship.loading = true;
      state.internship.error = false;
    },
    fetchInternshipSuccess(state, action) {
      state.internship.loading = false;
      state.internship.data = action.payload;
    },
    fetchInternshipFailure(state, action) {
      state.internship.loading = false;
      state.internship.error = action.payload;
    },

    fetchTrainingsStart(state)
    {
      state.trainings.loading = true;
      state.trainings.error = false;
    },
    fetchTrainingsSuccess(state, action) {
      state.trainings.loading = false;
      state.trainings.data = action.payload;
    },
    fetchTrainingsFailure(state, action) {
      state.trainings.loading = false;
      state.trainings.error = action.payload;
    },
    fetchTrainingDocsStart(state)
    {
      state.docs.loading = true;
      state.docs.error = false;
    },
    fetchTrainingDocsSuccess(state, action) {
      state.docs.loading = false;
      state.docs.data = action.payload;
    },
    fetchTrainingDocsFailure(state, action) {
      state.docs.loading = false;
      state.docs.error = action.payload;
    },
  },
});

export const {

  fetchTrainingDocsStart,
  fetchTrainingDocsSuccess,
  fetchTrainingDocsFailure,
  fetchTrainingsStart,
  fetchTrainingsSuccess,
  fetchTrainingsFailure,
  fetchResearchStart,
  fetchResearchSuccess,
  fetchResearchFailure,
  fetchPublicationStart,
  fetchPublicationSucces,
  fetchPublicationFailure,
  downloadFileStart,
  downloadFileSuccess,
  downloadFileFailure,
  fetchSocitiesStart,
  fetchSoctiesSuccess,
  fetchSocietiesFailure,
  fetchEventsStart,
  fetchEventsSuccess,
  fetchEventsFailure,
  fetchSportsStart,
  fetchSportsSuccess,
  fetchSportsFailure,
  fetchInternshipStart,
  fetchInternshipSuccess,
  fetchInternshipFailure,

} = researchAndStudentSlice.actions;

export const fetchTrainingsData = () => async (dispatch) => {
  dispatch(fetchTrainingsStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getPartner`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchTrainingsSuccess(data));
  } catch (error) {
    dispatch(fetchTrainingsFailure(error.message || "Something went wrong"));
  }
};

export const fetchTrainingDocs = () => async (dispatch) => {
  dispatch(fetchTrainingDocsStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getTrainingpartnerDocs`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchTrainingDocsSuccess(data));
  } catch (error) {
    dispatch(fetchTrainingDocsFailure(error.message || "Something went wrong"));
  }
};

export const fetchResearchData = () => async (dispatch) => {
  dispatch(fetchResearchStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getResearchByYear`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchResearchSuccess(data));
  } catch (error) {
    dispatch(fetchResearchFailure(error.message || "Something went wrong"));
  }
};

export const fetchPublicationData = () => async (dispatch) => {
  dispatch(fetchPublicationStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getResearchPublications`
    );
    const data = response.data.data || [];
    dispatch(fetchPublicationSucces(data));
  } catch (error) {
    dispatch(fetchPublicationFailure(error.message || "Something went wrong"));
  }
};

// Download publication file
export const downloadPublicationFile = (id) => async (dispatch) => {
  dispatch(downloadFileStart()); // Optional: If you need to manage loading state
  try {
    // Directly download the file via browser
    const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/downloadResearchFile/${id}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank"; // Open in new tab
    link.setAttribute("download", "publication.pdf"); // Default name for downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch(downloadFileSuccess()); // Optional: Dispatch success action
  } catch (error) {
    console.error("File download failed:", error);
    dispatch(downloadFileFailure(error.message || "Failed to download file")); // Optional: Dispatch failure action
  }
};

export const fetchSocietiesData = () => async (dispatch) => {
  dispatch(fetchSocitiesStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getClubSocities`
    );
    const data = response.data.data || [];
    dispatch(fetchSoctiesSuccess(data));
  } catch (error) {
    dispatch(fetchSocietiesFailure(error.message || "Something went wrong"));
  }
};

export const fetchEventsData = () => async (dispatch) => {
  dispatch(fetchEventsStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getStudentEvents`
    );
    const data = response.data.data || [];
    dispatch(fetchEventsSuccess(data));
  } catch (error) {
    dispatch(fetchEventsFailure(error.message || "Something went wrong"));
  }
};

export const fetchSportsData = () => async (dispatch) => {
  dispatch(fetchSportsStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getSports`
    );
    const data = response.data.data || [];
    dispatch(fetchSportsSuccess(data));
  } catch (error) {
    dispatch(fetchSportsFailure(error.message || "Something went wrong"));
  }
};


export const fetchInternshipData = () => async (dispatch) => {
  dispatch(fetchInternshipStart());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/researchandstudentlife/getCareerGuidanceAndInternship`
    );
    const data = response.data.data || [];
    dispatch(fetchInternshipSuccess(data));
  } catch (error) {
    dispatch(fetchInternshipFailure(error.message || "Something went wrong"));
  }
};
export default researchAndStudentSlice.reducer;
